// extracted by mini-css-extract-plugin
export var cardHeader = "_gb-0";
export var reorderHandle = "_gb-3";
export var titleArea = "_gb-1";
export var titleAreaWithHandle = "_gb-2";